/* eslint react/prop-types: 0 */
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { tokens, Button } from '@hotjar/hotsauce';
import { Icon } from '../Icon';

const UpsellBlock = styled.div`
  font-size: 14px;
  margin: 0 25px 15px 25px;
  background-color: ${tokens.color.ui_background};
  border-radius: 3px;
  border: 1px solid ${tokens.color.ui_border};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  padding: 15px;
  text-align: left;
`;

const Title = styled.h4`
  color: ${tokens.color.text_default};
  margin-bottom: 10px;
`;

const Message = styled.span`
  color: ${tokens.color.text_default};
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;

export const PollUpsell = ({ onCreatePollClick, ...otherProps }) => {
  return (
    /* FIXME: react/jsx-props-no-spreading */
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <UpsellBlock {...otherProps}>
      <Title>
        <Icon
          icon="polls"
          size={16}
          color={tokens.color.text_default}
          css={css`
            margin-right: 10px;
            margin-top: -2px;
          `}
        />
        Get more insight
      </Title>
      <Message>Want to know more about your user&apos;s experience?</Message>
      <Actions>
        <Button size="s" onClick={onCreatePollClick}>
          Create a Poll
        </Button>
      </Actions>
    </UpsellBlock>
  );
};
